import React from 'react';
import RoleView from './RoleView';

const RoleViewController = () => {
    return <RoleView />
};

export default RoleViewController;